module.exports = {
      id: "tamilnadu-usage",
      viewBox: "0 0 857.199 1020.664",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#tamilnadu",
      toString: function () {
        return this.url;
      }
    }